import { IApplicationState, TCardId } from '../../../../../../../types/types';

export const getFilterMatchCardIds = (
    state: IApplicationState
): TCardId[] => {
    return state.filters.filterMatch.cardIds || [];
}
